<template>
  <div>
    <data-table ref="dataTable" :option="option">
      <template slot="headAction">
        <a-button
          style="margin-left:10px"
          type="primary"
          @click="nightCheckBefore(0)"
          :loading="loading.nightCheckBefore"
        >
          夜审前检查
        </a-button>
        <a-popconfirm
          placement="right"
          title="你确定夜审吗?"
          @confirm="nightCheckBefore(1)"
          okText="确定"
          cancelText="取消"
        >
          <a-button
            style="margin-left:10px"
            type="primary"
            :loading="loading.executeNightCheck"
          >
            执行夜审
          </a-button>
        </a-popconfirm>
        <a-button
          style="margin-left:10px"
          type="primary"
          :loading="loading.statusCheck"
          @click="onNightCheckData(false)"
        >
          查看夜审状态
        </a-button>
      </template>
    </data-table>

    <a-modal
      title="夜审未处理房间"
      centered
      :maskClosable="false"
      v-model="visible.nightCheckRoomModal"
      width="60%"
    >
      <div>
        <!--style="height: calc(100vh - 250px)" -->
        <div style="text-align: right;margin-bottom: 10px;">
          <label class="headSearch">状态：</label>
          <a-select v-model="nightCheckRoomStatusValue" style="width: 150px">
            <a-select-option value="-1">请选择</a-select-option>
            <a-select-option
              v-for="(item, index) in nightCheckRoomStatus"
              :key="index"
              :value="item.Id"
              >{{ item.Text }}</a-select-option
            >
          </a-select>
          <a-button style="margin-left:20px" type="primary" @click="search">
            查询
          </a-button>
        </div>
        <data-grid
          ref="dataGrid"
          api="NightCheckStep_CheckRoomsList"
          :columns="columns"
          v-model="data"
          :pagination="true"
          :params="params"
          style="height: 500px;overflow: auto;"
          bordered
        >
          <template v-slot:action="slotProps">
            <a-button
              style="margin-left:10px"
              type="link"
              @click="orderDetail(slotProps)"
              >订单详情</a-button
            >
          </template>
        </data-grid>
      </div>
      <template slot="footer">
        <div v-if="showButton">
          当前设置为：允许夜审不处理应到未到的订单
          <a-button
            type="primary"
            @click="executeNightCheck"
            style="margin-left: 20px;"
          >
            执行夜审
          </a-button>
        </div>
        <div v-else></div>
      </template>
    </a-modal>

    <a-modal
      title="友情提示"
      centered
      :closable="false"
      :maskClosable="false"
      v-model="visible.messageModal"
      width="30%"
    >
      <template slot="footer">
        <a-button type="primary" @click="logout" :loading="loading.logout">
          确认
        </a-button>
      </template>
      <div style="padding: 10px;">
        夜审成功，请重新登录系统！
      </div>
    </a-modal>
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";
import { DataGrid } from "@/components/dataGrid";
import {
  OrderDetailModal,
  TeamOrderDetailModal
} from "@/views/orderManage/funtion.js";
import { mapActions } from "vuex";
import { cache, jump } from "@/utils/common";
const NightCheckStatus = {
  0: "未执行",
  1: "执行中",
  2: "Executed"
};
export default {
  name: "nightCheck_nightCheckStep",
  components: { DataTable, DataGrid },
  props: {},
  data() {
    return {
      visible: {
        nightCheckRoomModal: false,
        messageModal: false
      },
      loading: {
        nightCheckBefore: false,
        executeNightCheck: false,
        logout: false,
        statusCheck: false
      },
      nightCheckRoomStatus: [{ Id: null, Text: "请选择" }],
      nightCheckRoomStatusValue: "-1",
      data: [],
      params: { Status: null },
      showButton: false,
      nightCheckParam: null,
      defaultItem: {}
    };
  },
  created() {
    this.option = {
      grid: {
        api: "NightCheckStep_List",
        //pagination: false,
        //dataFeild: "Data",
        columns: [
          {
            title: "序号",
            width: "100px", //宽度
            align: "center", //对齐方式
            type: "indexcolumn" // 类型，indexcolumn = 序号
          },
          {
            title: "步骤序号",
            dataIndex: "StepNo",
            width: "20%"
          },
          {
            title: "步骤名称",
            dataIndex: "StepName"
          },
          {
            title: "状态",
            dataIndex: "StatusName",
            width: "20%"
          }
        ]
      }
    };
    this.columns = [
      {
        title: "序号",
        width: "50px", //宽度
        align: "center", //对齐方式
        type: "indexcolumn" // 类型，indexcolumn = 序号
      },
      {
        title: "订单号",
        dataIndex: "OrderNo",
        width: "15%"
      },
      {
        title: "房号",
        dataIndex: "RoomNo",
        width: "15%"
      },
      {
        title: "客人姓名",
        dataIndex: "GuestName",
        width: "20%"
      },
      {
        title: "房间状态",
        dataIndex: "StatusName",
        width: "20%"
      },
      {
        title: "操作",
        dataIndex: "Id",
        width: "160px",
        key: "action",
        //插槽 ，rowAction 默认的 编辑、删除 操作按钮插槽，如需其它按钮需自行定义插槽
        scopedSlots: { customRender: "action" }
      }
    ];
  },
  mounted() {
    this.$post("Room_GetDefaultTime", {}).then(res => {
      res.Data.SystemConstList.forEach(item => {
        this.defaultItem[item.Code] = item.Value;
      });
    });
    this.$post("Common_GetSelect", { Types: "NightCheckRoomStatus" }).then(
      res => {
        this.nightCheckRoomStatus = res.Data.NightCheckRoomStatus;
      }
    );
    this.$post("MaintenancePage_List", {
      Code: "NightCheckCancelBooking",
      Type: "SystemConstType",
      PageIndex: 0,
      PageSize: 1000
    }).then(res => {
      this.nightCheckParam = res.Data.Datas[0].Value;
    });
  },
  methods: {
    ...mapActions(["setMenus"]),
    nightCheckBefore(value) {
      if (value == 0) {
        this.loading.nightCheckBefore = true;
      } else {
        this.loading.executeNightCheck = true;
      }
      //先查询是否还有房间没处理
      this.$post("NightCheckStep_CheckRoomsList", {
        Status: null,
        PageIndex: 0,
        PageSize: 10
      })
        .then(res => {
          if (res.Data.Datas && res.Data.Datas.length > 0) {
            this.visible.nightCheckRoomModal = true;
            let item = res.Data.Datas.find(p => p.Status == 1);
            if (!item && this.nightCheckParam == "0") {
              this.showButton = true;
            } else {
              this.showButton = false;
            }
            // this.data = res.Data.Datas;
            // this.executeNightCheck();
            if (value == 0) {
              this.loading.nightCheckBefore = false;
            } else {
              this.loading.executeNightCheck = false;
            }
          } else {
            if (value == 0) {
              this.$message.info("无订单需要处理！");
              this.loading.nightCheckBefore = false;
            } else {
              this.executeNightCheck();
            }
          }
        })
        .catch(() => {
          if (value == 0) {
            this.loading.nightCheckBefore = false;
          } else {
            this.loading.executeNightCheck = false;
          }
        });
    },
    executeNightCheck() {
      this.visible.nightCheckRoomModal = false;
      this.$post("NightCheckStep_Execute")
        .then(() => {
          this.visible.messageModal = true;
          this.loading.executeNightCheck = false;
        })
        .catch(() => {
          this.loading.executeNightCheck = false;
        });
    },
    orderDetail(orderId) {
      if (this.defaultItem.PlusHotelOrderModel == 1) {
        TeamOrderDetailModal({
          orderId: orderId,
          update: () => {
            // this.params = { Status: null };
            this.$refs.dataGrid.reload();
            let item = this.data.find(p => p.Status == 1);
            if (!item && this.nightCheckParam == "0") {
              this.showButton = true;
            } else {
              this.showButton = false;
            }
          }
        });
      } else {
        OrderDetailModal({
          orderId: orderId,
          update: () => {
            // this.params = { Status: null };
            this.$refs.dataGrid.reload();
            let item = this.data.find(p => p.Status == 1);
            if (!item && this.nightCheckParam == "0") {
              this.showButton = true;
            } else {
              this.showButton = false;
            }
          }
        });
      }
    },
    search() {
      this.params = {
        Status:
          this.nightCheckRoomStatusValue == "-1"
            ? null
            : this.nightCheckRoomStatusValue
      };
    },
    logout() {
      this.loading.logout = true;
      this.$post("RemoveToken")
        .then(() => {
          cache.remove("user");
          this.$message.success("退出成功");
          this.setMenus([]);
          this.loading.logout = false;
          jump("login");
        })
        .catch(() => {
          this.loading.logout = true;
        });
    },
    onNightCheckData(isReset) {
      this.loading.statusCheck = true;
      const that = this;
      this.$post("NightCheckData", { isReset: isReset }, { alertError: false })
        .then(res => {
          const data = res.Data;
          this.loading.statusCheck = false;
          if (data) {
            if (!isReset) {
              this.$confirm({
                title: `是否重置夜审状态？`,
                okText: "重置",
                width: 550,
                okButtonProps: {
                  props: {
                    disabled: data.Status == 0
                  }
                },
                content: () => (
                  <div>
                    <p>
                      夜审状态：
                      <span style="color:red;">
                        【{NightCheckStatus[data.Status]}】
                      </span>
                    </p>
                    <p>操作员：【{data.UserCode}】</p>
                    <p>开始时间：【{data.BeginTime}】</p>
                  </div>
                ),
                onOk() {
                  that.onNightCheckData(true);
                }
              });
            } else {
              that.$message.success("操作成功");
            }
          }
        })
        .catch(error => {
          this.loading.statusCheck = false;
          if (error && error.data && error.data.Code == 0) {
            //
          } else if (error && error.data && error.data.Message) {
            this.$message.error(error.data.Message);
          }
        });
    }
  },
  // 计算属性
  computed: {},
  watch: {}
};
</script>

<style lang="less" scoped></style>
